import { render, staticRenderFns } from "./AccountSecurity.vue?vue&type=template&id=a52fb72c&scoped=true"
import script from "./AccountSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSecurity.vue?vue&type=script&lang=js"
import style0 from "./AccountSecurity.vue?vue&type=style&index=0&id=a52fb72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52fb72c",
  null
  
)

export default component.exports